import categoryEn from './categoryEn';
import categorySc from './categorySc';
import categoryTc from './categoryTc';

const searchBarCategory = { en: categoryEn, sc: categorySc, tc: categoryTc };

export default searchBarCategory;